import { useQuery } from '@tanstack/react-query';
import { preprocessForecast } from '../utils/forecast';

const fetchForecast = async (station, x, y) => {
  const response = await fetch(
    `https://api.weather.gov/gridpoints/${station}/${x},${y}`
  );
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const useForecast = (location) => {
  const response = useQuery({
    queryKey: ['weather', location.name],
    queryFn: () => fetchForecast(location.station, location.x, location.y),
    // Stale after 1 hour
    staleTime: 2 * 60 * 60 * 1000,
  });

  if (response.isLoading || response.isError) {
    return response;
  } else {
    return {
      ...preprocessForecast(response.data.properties),
      isLoading: false,
      isError: false,
    };
  }
};
